export const removeDuplicate = <T>(items: T[], by: keyof T): T[] => {
    const set = new Set();

    return items.filter((item) => {
        const isDuplicate = set.has(item[by]);
        set.add(item[by]);

        return !isDuplicate;
    });
};
